(function() {
    var is_loading = false; // initialize is_loading by false to accept new loading
    var id = 1;
    $(document).ready(function() {
        loadContent();
        $(window).scroll($.throttle( 250, function () {
            loadContent();
            })
        );
    });

    function loadContent(){
        if($(window).scrollTop() + $(window).height() >= $(document).height() - 400) {
            if (is_loading == false) {
                count = typeof count !== 'undefined' ? count : 20;
                tag = typeof tag !== 'undefined' ? tag : -1;
                // set is_loading to true to refuse new loading
                is_loading = true;
                // display the waiting loader
                $('.spinner').show();
                // execute an ajax query to load more statments
                $.ajax({
                    url: '/ajax/index',
                    type: 'GET',
                    data: {
                        page:id,
                        count: count,
                        tag: tag,
                        not_use: not_use,
                    },
                    headers:{
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success:function(data){
                        // now we have the response, so hide the loader
                        $('.spinner').hide();
                        // append: add the new statments to the existing data
                        $('#scrCont').append(data);
                        // set is_loading to false to accept new loading
                        is_loading = false;
                        id++;
                    }
                });
            }
        }
    }
})();
